import { createProxies } from "./proxies";

interface HealthCheckExportsMethods {
  GetEditorClientHealthCheck: () => Promise<string>;
}

export interface HealthCheckExports {
  HealthCheck: HealthCheckExportsMethods;
}

export const {
  setup,
  getEditorClientHealthCheck,
} = createProxies<HealthCheckExportsMethods>([
  "GetEditorClientHealthCheck",
]);
